
import { AssetEntityDecoratorBase } from './asset.decorator.base';


export class AssetEntityDecorator extends AssetEntityDecoratorBase {
  constructor() {
    super();
  }
}



